import LTR from "@brand-icons/ploom/lock-outline-open/lock-outline-open-ltr.svg";

import { iconFactory } from "../iconFactory";

export const LockOutlineOpenIcon = iconFactory("LockOutlineOpenIcon", LTR);
